export const LOCAL_STORAGE_AUTH_TOKEN_NAME = "app-auth-token";
export const LOCAL_STORAGE_AUTH_TOKEN_NAME_TEST = "app-auth-token-test";
